import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'store/store-hooks';
import { checkFoldersAvailable } from './_mediator/projects.slice';

import { PickerProvider } from './files-picker/picker.provider';
import { PickerGoogle__open, PickerGoogle__submit } from './files-picker/picker-google';
import { PickerReplace } from './files-picker/picker-replace';
import { SectionFolders } from './sections/section-folders';
import { SectionProjects } from './sections/section-projects';
import { SectionFiles } from './sections/section-files';
import { SectionStories } from './sections/section-stories';
import { SectionFinalCuts } from './sections/section-final-cuts';

import { AccessConfigModal } from './elements/modal-access-config';
import { StoryMenu } from './elements/story-menu';
import { ThumbPrev } from './sections/elements/thumb-prev';

import styles from './sections/_sections.module.scss';

export const Projects = () => {
  const foldersAvailable = useAppSelector((state) => state.projects.foldersAvailable);
  const projects = useAppSelector((state) => state.app__data.projects);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!projects) return;
    dispatch(checkFoldersAvailable());
  }, [projects?.length]);

  return (
    <div className={styles.Accordion}>
      {foldersAvailable && <SectionFolders />}
      <SectionProjects />
      <PickerProvider>
        <SectionFiles />
        <PickerGoogle__open />
        <PickerGoogle__submit />
        <PickerReplace />
      </PickerProvider>
      <SectionStories />
      <SectionFinalCuts />
      <StoryMenu />
      <ThumbPrev />
      <AccessConfigModal />
    </div>
  );
};
